import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import MainLayout from '../views/MainLayout.vue'
import EmuInsert from '../components/EmuInsert.vue'
import SsEmuInNameCdMst from '../components/SsEmuInNameCdMst.vue'
import SsEmuLinkMst from '../components/SsEmuLinkMst.vue'
import SsSystemCdMst from '../components/SsSystemCdMst.vue'
import SsWebAddrMst from '../components/SsWebAddrMst.vue'
import ReleaseAnnouncement from '../components/ReleaseAnnouncement.vue'
import TV1 from '../components/TV1.vue'
import TV2 from '../components/TV2.vue'
import TV3 from '../components/TV3.vue'
import UnServer from '../components/UnServer.vue'
import MailMiss from '../components/MailMiss.vue'
import Zhuizong from '../components/Zhuizong.vue'
import Kaiji    from '../components/Kaiji.vue'
import p404 from '../views/404.vue'

Vue.use(Router)

// export default new Router({
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  // base: process.env.VUE_APP_baseURL,
  routes: [
    {
      path: '/',
      name: 'login',
      meta: { no_need_login: true },// 添加该字段，表示进入这个路由是不需要登录的 (用到这个属性的router.beforeEach方法被注掉了)
      component: Login
    },{
      path: '/main',
      name: 'mainLayout',
      component: MainLayout,
      redirect:'/emuInsert',
      children:[
        { path: '/emuInsert',name: 'emuInsert',component: EmuInsert},
        { path: '/ssEmuInNameCdMst',name: 'ssEmuInNameCdMst',component: SsEmuInNameCdMst},
        { path: '/ssEmuLinkMst',name: 'ssEmuLinkMst',component: SsEmuLinkMst},
        { path: '/ssSystemCdMst',name: 'ssSystemCdMst',component: SsSystemCdMst},
        { path: '/ssWebAddrMst',name: 'ssWebAddrMst',component: SsWebAddrMst},
        {path: '/releaseAnnouncement', name: 'ReleaseAnnouncement',component: ReleaseAnnouncement},
        {path: '/UnServer', name: 'UnServer',component: UnServer},
        {path: '/MailMiss', name: 'MailMiss',component: MailMiss},
        {path: '/Zhuizong', name: 'Zhuizong',component: Zhuizong},
        {path: '/Kaiji',    name: 'Kaiji',   component: Kaiji   },
      ]
    },
        {path: '/TV1', name: 'TV1',meta: { no_need_login: true },component: TV1},
        {path: '/TV2', name: 'TV2',meta: { no_need_login: true },component: TV2},
        {path: '/TV3', name: 'TV3',meta: { no_need_login: true },component: TV3},
    {
      path: '/client/sendMail', name: 'sendMail', component: r => { require(['@/components/client/SendMail'], r) },
      meta: { no_need_login: true },
    },{
      path: '/*', 
      name: '404',
      meta: { no_need_login: true },// 添加该字段，表示进入这个路由是不需要登录的 (用到这个属性的router.beforeEach方法被注掉了)
      component: p404
    }
  ]
})

//-------------------导航守卫 start----------------------
//异步请求前判断请求的连接是否需要token  //下方被注掉的方法是第二种方式,那个方法用到了meta
// router.beforeEach((to, from, next) => {
//   if (to.path === '/' || to.path.indexOf('/client')>=0) {
//     next();
//   } else {
//     let token = localStorage.getItem('Authorization');
//     let realToken = sessionStorage.getItem('RealToken');
//     // console.log("我是浏览器本地缓存的token: "+token);
//     if (!realToken || token!=realToken) {
//       next('/');
//     } else {
//       next();
//     }
//   }
// });

router.beforeEach((to, from, next) => {
  if (to.matched.some(function (item) {
    // console.log("不需要登录"+item.meta.no_need_login);
    return item.meta.no_need_login
  })) {
    next()
  } else {
    if (sessionStorage.RealToken) {  // 通过vuex state获取当前的token是否存在
      next();
    }
    else {
      next({
          path: '/404',
          // query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }
})

export default router
